var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Profile" },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function() {
              return [
                _vm.isEditedProfile
                  ? _c("Button", {
                      attrs: { variant: "default", label: "Cancel" },
                      on: { clicked: _vm.toggleEditProfile }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isEditedProfile
                  ? _c("Button", {
                      attrs: { variant: "primary", label: "Edit Profile" },
                      on: { clicked: _vm.toggleEditProfile }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEditedProfile
                  ? _c("Button", {
                      attrs: { variant: "primary", label: _vm.labelSaveButton },
                      on: { clicked: _vm.saveProfile }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function() {
              return [
                !_vm.isEditedProfile
                  ? _c("ViewProfile", { attrs: { user: _vm.getUser } })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isEditedProfile
                  ? _c("EditProfile", {
                      ref: "editProfile",
                      attrs: {
                        user: _vm.getUser,
                        emailErrorMessage: _vm.emailErrorMessage,
                        imageErrorMessage: _vm.imageErrorMessage
                      }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ced23842", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ced23842","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile.vue
// module id = null
// module chunks = 